import React from 'react';
// import Plot from 'react-plotly.js';
import { connect } from 'react-redux';
import moment from 'moment';
import { withRouter } from 'react-router-dom';
import 'whatwg-fetch';
import { get, uniq, differenceBy, unzip } from 'lodash';
import {
  translate as t,
  GET_LIST,
  Restricted,
} from 'admin-on-rest';
import {
  SelectField,
  MenuItem,
  Chip,
  RaisedButton,
  DatePicker,
  AutoComplete,
  Checkbox,
  Card,
  CircularProgress,
} from 'material-ui';
import { pure } from 'recompose';

import { callApi } from '../client/apiToolbox';
import { getTranslationByLocale } from '../utils/TranslationUtils';

import { kunal } from '../client';
import kunalClient from '../client/kunalClient';
import preloader from './utils/preloader';
import { regscape } from '../utils/StringUtils';

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:4042/api';
const restClient = kunalClient(API_BASE_URL, kunal);
const Plot = preloader(() => import('react-plotly.js'));

const styles = {
  chipStyle: {
    display: 'inline-flex',
    margin: '4px',
    height: '36px',
    lineHeight: '36px',
  },
  loadingWrapper: {
    display: 'flex',
    justifyContent: 'center',
    zIndex: '99',
    left: '0',
    right: '0',
    marginLeft: 'auto',
    marginRight: 'auto',
    position: 'absolute',
    width: '25%',
    height: '15%',
    top: '30%',
    backgroundColor: '#D3D3D3',
    textAlign: 'center',
  },
  fieldDivs: {
    padding: '10px 0 10px 0',
  },
};

class PlotViewer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      bigdata: [],
      venues: [],
      allVenuesSelected: false,
      dateFrom: moment().startOf('month')._d,
      dateTo: moment()._d,
      period: 'daily',
      isLoadingFetch: false,
      searchText: '',
      dates: [],
      values: [],
      xaxis: {},
    };
  }

  componentWillMount = async () => {
    this.setState({ isLoadingState: true });
    await this.bigdataCall();

    await restClient(GET_LIST, 'venues', {
      sort: {},
      pagination: {},
      filter: {},
    })
      .then((venues) => {
        const formattedVenues = this.dataConfigFormatter(venues.data, this.props.locale);
        this.setState({ initialVenues: formattedVenues, venues: formattedVenues }, () => this.setState({ isLoadingState: false }));
      })
      .catch(() => this.props.showNotification('Could not get venues', 'warning'));

    this.handleSelectAllVenues(this.state.initialVenues, 'venues');
  }

  onDateFromChange = (event, date) => this.setState({ dateFrom: date });

  onDateToChange = (event, date) => this.setState({ dateTo: date });

  dataConfigFormatter = (c, locale) => c.map((choice) => ({ ...choice, text: getTranslationByLocale(choice.title, locale) }));

  handleSelectAllVenues = (choices, source) => {
    if (this.state.allVenuesSelected) {
      this.setState({ [source]: [] });
    } else {
      this.setState({ [source]: this.state.initialVenues }, () => this.setState({ isLoadingState: false })); // render page when the loading is done
    }
    this.setState((prevState) => ({ allVenuesSelected: !prevState.allVenuesSelected }));
  }

  handlePeriodChange = (event, index, value) => this.setState({ period: value })

  bigdataCall = () => {
    const { venues, dateFrom, dateTo, period: periodInterval } = this.state;
    const { id: productCode } = this.props.match.params;
    const { locale } = this.props;
    const period = {
      from: moment(dateFrom).format('YYYYMMDD'),
      to: moment(dateTo).format('YYYYMMDD'),
      period: periodInterval,
    };
    this.setState({ isLoadingFetch: true });
    callApi(`${API_BASE_URL}/utils/bigdata2/${productCode}`, 'POST', { 'Content-Type': 'application/json', credentials: 'include' },
      {
        locale,
        period,
        venues: venues.length > 0 ? venues : undefined,
      }
    ).then((data) => {
      console.log('data', data);
      const plotData = data.json.map((arr) =>
        unzip(arr)).map((arr, i) =>
        ({
          x: this.sortDates(arr[0].map(((date) =>
            this.formatDates(date)))),
          y: arr[1],
          type: 'line',
          tickmode: 'array',
          yaxis: `y${i + 1}`,
          name: i === 0 ? 'Total Sales' : i === 1 ? 'Per Guest' : 'Venue',
        }));

      this.setState({ plotData, xaxis: this.formatXaxis() }, () => { this.setState({ isLoadingFetch: false }); console.log(this.state.plotData); });
    })
      .catch((e) => { this.setState({ isLoadingFetch: false }); console.log('ERROR', e); });
  }

  handleUpdateInput = (searchText, source) => {
    const field = `searchText${source.charAt(0).toUpperCase() + source.slice(1)}`; // e.g. searchTextVenues, searchTextProducts
    this.setState({ [field]: searchText });
  }

  handleNewRequest = (chosenRequest, index, locale, source) => {
    const searchField = `searchText${source.charAt(0).toUpperCase() + source.slice(1)}`;
    const selectAllField = `all${source.charAt(0).toUpperCase() + source.slice(1)}Selected`; // e.g. allVenuesSelected, allProductsSelected
    const selectAllState = this.state[selectAllField];
    let resource;

    // if all of something is selected -> that selection is cancelled if the user adds a specific item
    if (selectAllState) {
      resource = [chosenRequest];
    } else {
      resource = [...this.state[source]];
    }

    resource.push(chosenRequest);

    // remove duplicates
    resource = uniq(resource);

    this.setState({ [source]: resource, [searchField]: '', [selectAllField]: false });
  }

  handleRemoveChip = (id, source) => {
    let resource = this.state[source];

    resource = resource.filter((item) => item._id !== id);

    this.setState({ [source]: resource });
  }

  formatPlotData = (x, y) => ({ x: [...x], y: [...y] }) // input are arrays

  filterChosenItems = (choices, selected) => {
    if (selected.length > 0) {
      return differenceBy(choices, selected, '_id');
    }
    return choices;
  }

  formatDates = (date) => {
    const { period } = this.state;
    switch (period) {
      case 'daily':
        return date.replace(/\//g, '-');
      case 'weekly':
        return date.split('/')[1];

      case 'monthly':
        return date.split('/')[1];

      case 'quarterly':
        return date.split('Q')[1];

      default:
        return date;
    }
  }

  sortDates = (dateArray) => {
    const { period } = this.state;
    return period === 'daily' ? dateArray.sort((a, b) => moment(a, 'YY-MM-DD').valueOf() - moment(b, 'YY-MM-DD').valueOf()) : dateArray.sort((a, b) => a - b);
  }

  formatXaxis = () => {
    const { period } = this.state;
    return period === 'daily' ? { tickmode: 'auto', domain: [0, 0.9] } : { tickmode: 'linear', dtick: 1, domain: [0, 0.9] };
  }

  render() {
    const { id: productCode } = this.props.match.params;
    const { locale, location } = this.props;
    const { dateFrom, dateTo, period, isLoadingState, isLoadingFetch, initialVenues, venues, xaxis, plotData } = this.state;

    return (
      <Restricted authParams={{ route: `/statistics/${productCode}` }} location={location}>
        <Card style={{ padding: '20px' }}>
          {
            isLoadingState ? (
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <CircularProgress size={60} thickness={7} />
              </div>
            )
              : (
                <div style={{ padding: '10px 0 10px 0' }}>
                  <VenueField
                    choices={this.filterChosenItems(initialVenues, venues)}
                    handleNewRequest={this.handleNewRequest}
                    handleUpdateInput={this.handleUpdateInput}
                    handleSelectAll={this.handleSelectAllVenues}
                    locale={locale}
                    selectAll={this.state.allVenuesSelected}
                    selectValue={venues}
                    searchText={this.state.searchTextVenues}
                    source="venues"
                  />
                  <div style={styles.fieldDivs}>
                    <ChipRenderer handleRequestDelete={this.handleRemoveChip} values={venues} source="products" locale={locale} />
                  </div>
                  <div style={styles.fieldDivs}>
                    <DatePicker hintText="From" container="inline" onChange={this.onDateFromChange} value={dateFrom} />
                    <DatePicker hintText="To" container="inline" mode="landscape" onChange={this.onDateToChange} value={dateTo} />
                    <SelectField value={period} onChange={this.handlePeriodChange} floatingLabelText="Period">
                      <MenuItem key="daily" primaryText="daily" value="daily" />
                      <MenuItem key="weekly" primaryText="weekly" value="weekly" />
                      <MenuItem key="monthly" primaryText="monthly" value="monthly" />
                      <MenuItem key="quarterly" primaryText="quarterly" value="quarterly" />
                      <MenuItem key="yearly" primaryText="yearly" value="yearly" />
                    </SelectField>
                  </div>
                  <div style={styles.fieldDivs}>
                    <RaisedButton style={{ margin: '20px 0 20px 0' }} label="Query" onClick={this.bigdataCall} />
                  </div>
                  <Plotter data={plotData} title={productCode} xaxis={xaxis} />
                </div>
              )
          }

          {
            (isLoadingFetch && !isLoadingState) &&
            <div style={styles.loadingWrapper}>
              <div style={{ marginLeft: 'auto', marginRight: 'auto', position: 'relative' }}>
                <h3>Fetching data...</h3>
                <CircularProgress size={60} thickness={7} />
              </div>
            </div>
          }
        </Card>
      </Restricted>
    );
  }
}

const VenueField = pure(({ source, choices = [], locale, searchText, handleUpdateInput, handleNewRequest, selectAll, handleSelectAll }) => (
  <div>
    <AutoComplete
      floatingLabelText="Venues"
      fullWidth
      dataSource={choices}
      dataSourceConfig={{ text: 'text', value: 'id' }}
      searchText={searchText}
      onUpdateInput={(searchText) => handleUpdateInput(searchText, source)} // eslint-disable-line no-shadow
      onNewRequest={(req, i) => handleNewRequest(req, i, locale, source)}
      filter={(searchText, key) => ( // eslint-disable-line no-shadow
        new RegExp(
          regscape(searchText),
          'gi'
        ).test(key) // @returns bool
      )}
      openOnFocus
      listStyle={{ maxHeight: 600, overflow: 'auto' }}
      disabled={selectAll}
    />
    <Checkbox label="Select All Venues" checked={selectAll} onClick={() => handleSelectAll(choices, source)} primaryText="Select All" />
  </div>
));

const ChipRenderer = ({ values, handleRequestDelete, locale, source }) => (
  <div style={{ display: 'flex', flexWrap: 'wrap' }}>
    {
      values.length > 10 ?
        `${values.length} ${source} selected.` :
        values.map((val) => <Chip style={{ marginTop: '5px' }} onRequestDelete={() => handleRequestDelete(val._id, source)} key={val._id}>{getTranslationByLocale(val.title, locale)}</Chip>)}
  </div>
);

const Plotter = ({ data, title, xaxis }) => (<Plot
  data={data}
  layout={{
    autosize: true,
    title,
    xaxis,
    yaxis: { title: 'Total Sales' },
    yaxis2: { title: 'Per Guest', overlaying: 'y', side: 'right', anchor: 'free', position: 1 },
    // yaxis3: { title: 'Venues', overlaying: 'y', side: 'right', anchor: 'x' }, // waiting for correct data from server before using
    legend: { orientation: 'h', y: 1.15 },
  }}
  style={{ width: '100%' }}
  config={{ responsive: true }}
/>);

export default connect(
  (state) => ({ permissions: get(state, 'auth.permissions'), user: get(state, 'auth.user') }),
  {}
)(withRouter(t(PlotViewer)));
